<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-account" icon-small title="لیست مشتریان" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" lg="12">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table dense :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :items="customers" :items-per-page="500" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td><small>{{ row.item.name }}</small></td>
										<td>{{ row.item.code }}</td>
										<td>{{ row.item.mobile }}</td>
										<td>{{ row.item.email }}</td>
										<td class="text-center">
											{{ row.item.firstLoginDone ? 'بلی' : 'خیر' }}
										</td>
										<td class="text-center">
											{{ row.item.initPassword }}
										</td>
										<td class="text-center">
											{{ row.item.regDate_Persian.date }}
										</td>
										<td class="text-center">
											{{ row.item.expireDate_Persian.date }}
										</td>
										<td class="text-center">
											{{ row.item.purchased ? 'بلی' : 'خیر' }}
										</td>
										<td class="text-center">
											{{ row.item.permanent ? 'بلی' : 'خیر' }}
										</td>
										<td class="text-center">
											{{ row.item.affCode }}
										</td>
										<td class="text-right">
											<div><small>تعداد مشتری: </small> <small class="red--text">{{ row.item.membersCount }}</small></div>
											<div><small>تعداد تعریف وام: </small> <small class="red--text">{{ row.item.loansCount }}</small></div>
											<div><small>تعداد پرونده: </small> <small class="red--text">{{ row.item.userLoansCount }}</small></div>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'MembersView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				search: '',
				loading: false,
				headers: [
					{
						text: 'نام',
						align: 'start',
						sortable: true,
						value: 'name',
						width: 120
					}, {
						text: 'کد',
						align: 'center',
						sortable: true,
						value: 'code',
					}, {
						text: 'موبایل',
						align: 'start',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'ایمیل',
						align: 'start',
						sortable: true,
						value: 'email',
					}, {
						text: 'اولین ورود',
						align: 'center',
						sortable: true,
						value: 'firstLoginDone',
					}, {
						text: 'پسورد اولیه',
						align: 'center',
						sortable: true,
						value: 'initPassword',
					}, {
						text: 'تاریخ ثبت نام',
						align: 'center',
						sortable: true,
						value: 'regDate_Persian.date',
					}, {
						text: 'تاریخ انقضا',
						align: 'center',
						sortable: true,
						value: 'expireDate_Persian.date',
					}, {
						text: 'خرید',
						align: 'center',
						sortable: true,
						value: 'purchased',
					}, {
						text: 'نسخه دائمی',
						align: 'center',
						sortable: true,
						value: 'permanent',
					}, {
						text: 'کد معرف',
						align: 'center',
						sortable: true,
						value: 'affCode',
					},
					, {
						text: 'آمار',
						align: 'right',
						sortable: true,
						value: 'membersCount',
						width: 150
					},
				],
				customers: []
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('superadmin/customer/list/', null)
					.then(
						response => {
							this.customers = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
		},
	}
</script>
<style></style>
